export default __webpack_public_path__ + "static/media/hippo_sit_stroke.bfc47024.png";